export default __webpack_public_path__ + "static/media/xbox.fcfec7b0.svg";